//packages
import React, { Component } from 'react'

//form elements
import PopoverOfForm from '../../PopoverOfForm'

class NatureOfSuitTooltip extends Component {
    render () {
        return (
            <PopoverOfForm>
                <p>Leave this field blank (do not select any entries) in order to match all Nature of Suit codes.
                        Otherwise, select the Nature of Suit you want to match from the drop down list. You can select
                        multiple entries by holding down the Control key while clicking.</p>
            </PopoverOfForm>
        )
    }
}

export default NatureOfSuitTooltip



// WEBPACK FOOTER //
// ./src/components/search/FormElements/tooltips/NatureOfSuitTooltip/NatureOfSuitTooltip.js